/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:06]
Permissions to update outside the main branch: [false]
*/

import {
    DropDown,
    selectOptionsToDropDown,
    useWorkplaceState,
    ValidatedDropDownList,
} from '@finbeat/react-toolkit';
import { AxiosError } from 'axios';
import { getOutletsAll } from 'axios/outletsApi';
import { getTradeOrgsList } from 'axios/tradeOrgsApi';
import useApi from 'hooks/useApi';
import { t } from 'i18next';
import { AxiosErrorResponse } from 'models/api/axiosErrorResponse';
import { SelectOption } from 'models/api/prop';
import { UserItem } from 'models/api/users';
import { Key, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useQuery } from 'react-query';

type TradeOrgTabProps = {
    disabled: boolean;
    toggle: (tab?: Key) => void;
};

const TradeOrgTab = ({ disabled, toggle }: TradeOrgTabProps) => {
    const api = useApi();
    const { handleError } = useWorkplaceState();
    const [tradeOrgs, setTradeOrgs] = useState<SelectOption[] | null>();
    const [outlets, setOutlets] = useState<DropDown[] | null>();
    const { watch, setValue } = useFormContext<UserItem>();
    const tradeOrgId = watch('tradeOrgId');

    const { isFetching: tradeOrgsLoading } = useQuery('TradeOrgs', () => getTradeOrgsList(api), {
        onSuccess: (props) => {
            setTradeOrgs(props);
        },
        enabled: tradeOrgs == null,
        onError: (e: AxiosError<AxiosErrorResponse>) => handleError(e.response?.data),
    });

    const { isFetching: outletsLoading } = useQuery(
        ['Outlets', tradeOrgId],
        () => getOutletsAll(api, tradeOrgId),
        {
            onSuccess: (props) => {
                setOutlets(props);
            },
            enabled: outlets == null,
            onError: (e: AxiosError<AxiosErrorResponse>) => handleError(e.response?.data),
        }
    );

    return (
        <>
            <ValidatedDropDownList<UserItem>
                name="tradeOrgId"
                label={t('BackOfficeTradeOrg')}
                disabled={disabled}
                isLoading={tradeOrgsLoading}
                items={selectOptionsToDropDown(tradeOrgs || [])}
                onValueChange={() => {
                    setValue('outletIds', []);
                    setOutlets(null);
                }}
            />
            <ValidatedDropDownList<UserItem, true>
                name="outletIds"
                label={t('BackOfficeOutlets')}
                disabled={disabled || tradeOrgId == null}
                isLoading={outletsLoading}
                items={outlets || []}
                isMulti
            />
        </>
    );
};

export default TradeOrgTab;
